module.exports = __webpack_public_path__ + "static/media/icon-checkbox-grey-outline.ee7310e4.svg";